function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M7.984 14.655V9.748L3.688 7.259v4.79c0 .034.008.067.026.098s.044.057.08.08l4.19 2.428zm1.032 0l4.19-2.429a.228.228 0 00.08-.079.197.197 0 00.026-.099V7.26L9.017 9.748v4.907zM7.879 15.78l-4.601-2.648a1.224 1.224 0 01-.622-1.073V6.844a1.218 1.218 0 01.622-1.073l4.6-2.649a1.224 1.224 0 011.243 0l4.601 2.649a1.224 1.224 0 01.622 1.073v5.215a1.218 1.218 0 01-.622 1.073l-4.6 2.648a1.224 1.224 0 01-1.243 0zm3.272-8.46l1.594-.915-4.14-2.394a.198.198 0 00-.105-.033.198.198 0 00-.106.033l-1.492.86 4.249 2.45zM8.5 8.86l1.598-.926L5.853 5.48l-1.598.925L8.5 8.86z",
  fill: "gray"
});
function SvgPaquete(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref);
}
export default __webpack_public_path__ + "/img/Paquete.svg";
export { SvgPaquete as ReactComponent };